import React, { useState } from "react";
import InvoiceForm from "./Main";

const ACCOUNT_ID = 1;

const DEFAULT_VALUE = {
  vendor: {
    current: {
      value: "",
      name: "",
    },
    reference: {
      reference_id: 26112,
    }
  },
  invoice_number: {
    current: {
      value: "",
      warning: null,
      message: 'Please be careful entering the invoice number. This is a critical field for matching invoices to payments.',
    },
    reference: {
      current_value: "INV0001",
    }
  },

  invoice_date: {
    current: {
      value: "",
    },
    reference: {
      current_value: "08/31/2024",
    }
  },

  invoice_amount: {
    current: {
      value: "",
    },
    reference: {
      current_value: "100.00",
    }
  },
}

const DEFAULT_LINE_ITEMS = [
  {
    item_number: {
      current: {
        value: "",
      },
      reference: {
        reference_id: "962064",
      }
    },
    item_name: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    qty: {
      current: {
        value: "",
      },
      reference: {
        current_value: "10",
      }
    },
    unit_price: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
    category: {
      current: {
        value: "",
      },
      reference: {
        reference_id: "72",
      }
    },
    subtotal: {
      current: {
        value: "100.57",
      },
      reference: {
        current_value: "100.00",
      }
    },
  },
  {
    item_number: {
      current: {
        value: "",
      },
      reference: {
        reference_id: "962064",
      }
    },
    item_name: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    qty: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    unit_price: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
    category: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    subtotal: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
  }
]

const Play = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})
  const [line_items, setLineItems] = useState([...DEFAULT_LINE_ITEMS])

  return (
    <>
      <InvoiceForm
        account_id={ACCOUNT_ID}
        invoice_info={{...DEFAULT_VALUE}}
        invoice_line_items={[...DEFAULT_LINE_ITEMS]}
        onChangeInvoiceInfo={(val) => setValue(val)}
        onChangeLineItems={(val) => setLineItems(val)}
      />

      <hr/>

      <p className="alert alert-info">
        Vendor Value: {value?.vendor?.current?.value} {value?.vendor?.current?.name}
        <br/>
        Invoice Number Value: {value?.invoice_number?.current?.value}
        <br/>
        Invoice Date Value: {value?.invoice_date?.current?.value}
        <br/>
        Invoice Amount Value: {value?.invoice_amount?.current?.value}
        <br/>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Item Number</th>
              <th>Item Name</th>
              <th>Category</th>
              <th>QTY</th>
              <th>Unit Price</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {line_items.map((line_item, index) => (
              <tr>
                <td>{line_item.item_number?.current?.value}</td>
                <td>{line_item.item_name?.current?.item_name}</td>
                <td>{line_item.category?.current?.value}</td>
                <td>{line_item.qty?.current?.value}</td>
                <td>{line_item.unit_price?.current?.value}</td>
                <td>{((parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0)).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5">Total</td>
              <td>
                {(line_items.reduce((acc, line_item) => {
                  return acc + (parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0);
                }, 0.00)).toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </table>
      </p>


      <p className="alert alert-secondary">
        Vendor Value: {DEFAULT_VALUE?.vendor?.reference?.reference_id} {DEFAULT_VALUE?.vendor?.current?.name}
        <br/>
        Invoice Number Value: {DEFAULT_VALUE?.invoice_number?.reference?.current_value}
        <br/>
        Invoice Date Value: {DEFAULT_VALUE?.invoice_date?.reference?.current_value}
        <br/>
        Invoice Amount Value: {DEFAULT_VALUE?.invoice_amount?.reference?.current_value}
        <br/>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Item Number</th>
              <th>Item Name</th>
              <th>Category</th>
              <th>QTY</th>
              <th>Unit Price</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {DEFAULT_LINE_ITEMS.map((line_item, index) => (
              <tr>
                <td>{line_item.item_number?.reference?.reference_id}</td>
                <td>{line_item.item_name?.reference?.reference_id}</td>
                <td>{line_item.category?.reference?.reference_id}</td>
                <td>{line_item.qty?.reference?.current_value}</td>
                <td>{line_item.unit_price?.reference?.current_value}</td>
                <td>{((parseFloat(line_item.qty?.reference?.vacurrent_valuelue) || 0.00) * (parseFloat(line_item.unit_price?.reference?.current_value) || 0)).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5">Total</td>
              <td>
                {(DEFAULT_LINE_ITEMS.reduce((acc, line_item) => {
                  return acc + (parseFloat(line_item.qty?.reference?.value) || 0.00) * (parseFloat(line_item.unit_price?.reference?.value) || 0);
                }, 0.00)).toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </table>
      </p>
    </>
  )
}

export default Play;
